<script>
  import { format } from 'svelte-i18n';

  import { Spinner } from '@client/components/spinner';
  import { Table } from '@client/components/table';

  import { DiffCell } from '../cell-formatters';

  export let rows = [];

  let columns = [
    {
      key: 'tier',
      title: $format('label.TIER'),
      value: ({ tier }) => tier,
      sortable: true
    },
    {
      key: 'active',
      title: $format('label.ACTIVE'),
      value: ({ active }) => active,
      sortable: true
    },
    {
      key: 'sold',
      title: $format('label.SOLD'),
      value: ({ sold }) => sold,
      sortable: true
    },
    {
      key: 'diff',
      title: $format('label.DIFF'),
      value: ({ diff }) => diff,
      renderComponent: DiffCell,
      sortable: true
    }
  ];
</script>

{#if rows.length}
  <Table id="domain-usage" bind:rows bind:columns sortBy="due_date" sortOrder={-1} />
{:else}
  <div class="loader">
    <Spinner show />
  </div>
{/if}

<style lang="scss" src="./usage.scss"></style>
